import { render, staticRenderFns } from "./main-banner.component.vue?vue&type=template&id=8442a566"
import script from "./main-banner.component?vue&type=script&lang=ts&external"
export * from "./main-banner.component?vue&type=script&lang=ts&external"
import style0 from "./main-banner.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports